// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { isCanada } from '@tcp/core/src/utils';
import { configureInternalNavigationFromCMSUrl } from '@tcp/core/src/utils/utils';
import MyOffersCoupons from '@tcp/core/src/components/features/account/common/organism/MyOffersCoupons';
import PlaceRewardsLabels from '@tcp/core/src/components/features/account/PlaceRewards/PlaceRewards.labels';
import styles from '../styles/PlaceRewards.section.style';
import MyRewards from '../../../../common/organism/MyRewards';
import RewardsPoints from '../../../../common/organism/RewardsPoints';
import PointsHistory from '../../../../common/organism/PointsHistory';
import EarnExtraPointsTileContainer from '../../../../common/organism/EarnExtraPointsTile';
import BonusPointsDays from '../../../molecules/BonusPointsDays';
import Anchor from '../../../../../../common/atoms/Anchor';

const PlaceRewardsSection = ({
  className,
  isBonusPointsEnabled,
  commonLabels,
  isBonusPointDayEnabled,
  isPlacePerkEnabled,
  ...otherProps
}) => {
  const placeRewardsLabels = getLabelFromCopyOrFromTranslation(
    'global.placeRewards',
    PlaceRewardsLabels
  );
  const globalGenericLabels = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_GENERIC_LABELS}`,
    GlobalGenericLabels
  );
  const isCA = isCanada();

  return (
    <div className={className}>
      <Row fullBleed>
        <BodyCopy component="div" className="elem-mb-MED account-dashboard-goback-link">
          <Anchor
            fontSizeVariation="xlarge"
            anchorVariation="secondary"
            to="/account?id=account-overview"
            asPath="/account"
          >
            <span className="left-arrow" />
            {renderLabel(
              getLabelFromCopyOrFromTranslation(
                `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
                GlobalActionsLabels
              ),
              'lbl_back'
            )}
          </Anchor>
        </BodyCopy>
        <Col
          colSize={{
            small: 6,
            large: 12,
            medium: 8,
          }}
        >
          <BodyCopy
            fontFamily="secondary"
            fontSize="fs16"
            fontWeight="extrabold"
            component="h2"
            className="place-rewards__heading myAccountRightView"
            data-locator="place-rewards-heading"
          >
            {renderLabel(
              getDynamicLabelValues('dynamic.account_d.ACC_LBL_PLACE_REWARDS_HEADING'),
              'ACC_LBL_PLACE_REWARDS_HEADING'
            )}
          </BodyCopy>
        </Col>
      </Row>
      <Row fullBleed>
        {!isCA && (
          <Row fullBleed className="place-rewards-sections-row1">
            <Col
              colSize={{
                small: 6,
                large: 6,
                medium: 4,
              }}
              className="place-rewards-col1"
            >
              <Row fullBleed>
                <Col
                  colSize={{
                    small: 4,
                    large: 10,
                    medium: 6,
                  }}
                >
                  <BodyCopy
                    fontFamily="secondary"
                    fontSize="fs16"
                    fontWeight="extrabold"
                    component="h3"
                    className="elem-mb-SM elem-mt-XXXS"
                  >
                    {renderLabel(
                      placeRewardsLabels.lbl_my_rewards_point_balance,
                      'lbl_my_rewards_point_balance'
                    )}
                  </BodyCopy>
                </Col>
              </Row>
              <Row fullBleed className="elem-mb-MED reward-points">
                <Col
                  colSize={{
                    small: 4,
                    large: 10,
                    medium: 6,
                  }}
                  className="reward-points-section"
                >
                  <div className="my-place-reward-section">
                    <RewardsPoints />
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              colSize={{
                small: 6,
                large: 6,
                medium: 4,
              }}
              className="place-rewards-col2"
            >
              <BodyCopy component="div" className="place-rewards-right-col">
                <Row fullBleed>
                  <Col
                    colSize={{
                      small: 4,
                      large: 10,
                      medium: 6,
                    }}
                  >
                    <BodyCopy
                      fontFamily="secondary"
                      fontSize="fs16"
                      fontWeight="extrabold"
                      component="h3"
                      className="elem-mb-SM elem-mt-XXXS"
                      data-locator="pointshistorylbl"
                    >
                      {renderLabel(
                        placeRewardsLabels.lbl_my_rewards_points_history,
                        'lbl_my_rewards_points_history'
                      )}
                    </BodyCopy>
                  </Col>
                </Row>
                <Row fullBleed className="elem-mb-MED">
                  <Col
                    colSize={{
                      small: 6,
                      large: 11,
                      medium: 8,
                    }}
                  >
                    <PointsHistory />
                  </Col>
                </Row>
              </BodyCopy>
            </Col>
          </Row>
        )}
        <Row fullBleed className="place-rewards-sections-row2">
          {isBonusPointsEnabled && (
            <Col
              colSize={{
                small: 6,
                large: 6,
                medium: 4,
              }}
              className="place-rewards-col3"
            >
              <div className="bonusPointsWrapper">
                <BonusPointsDays isDefaultOpen isPlaceRewardsPage />
              </div>
            </Col>
          )}
          <Col
            colSize={{
              small: 6,
              large: 6,
              medium: 4,
            }}
            className="place-rewards-col4"
          >
            <BodyCopy
              component="div"
              className={`${isBonusPointsEnabled ? 'place-rewards-right-col' : 'elem-mr-LRG'}`}
            >
              <EarnExtraPointsTileContainer />
            </BodyCopy>
          </Col>
        </Row>
      </Row>
      {!isCA && (
        <div className={isBonusPointDayEnabled ? `place-rewards-sections-row3` : ''}>
          <MyRewards showLink={!isBonusPointDayEnabled} {...otherProps} />
        </div>
      )}
      {isBonusPointDayEnabled && (
        <>
          <MyOffersCoupons isPlacePerks isPlacePerkEnabled={isPlacePerkEnabled} fromPlaceRewards />
          <div className="bottomContainer">
            <Col
              colSize={{
                small: 3,
                large: 6,
                medium: 4,
              }}
              className="textRight"
            >
              <Anchor
                fontSizeVariation="medium"
                underline
                url={renderLabel(
                  getDynamicLabelValues('dynamic.account_d.lbl_rewardprogram_link'),
                  'lbl_rewardprogram_link'
                )}
                anchorVariation="primary"
                dataLocator="my-rewards-program-details"
                className="elem-mr-SM"
                target="_blank"
              >
                {renderLabel(globalGenericLabels.lbl_program_details, 'lbl_program_details')}
              </Anchor>
            </Col>
            <Col
              colSize={{
                small: 3,
                large: 6,
                medium: 4,
              }}
            >
              <Anchor
                fontSizeVariation="medium"
                underline
                to={configureInternalNavigationFromCMSUrl(
                  renderLabel(
                    getDynamicLabelValues('dynamic.account_d.lbl_termcondition_link'),
                    'lbl_termcondition_link'
                  )
                )}
                asPath={renderLabel(
                  getDynamicLabelValues('dynamic.account_d.lbl_termcondition_link'),
                  'lbl_termcondition_link'
                )}
                anchorVariation="primary"
                dataLocator="my-rewards-tnc"
                className="elem-ml-SM"
                target="_blank"
              >
                {renderLabel(globalGenericLabels.lbl_tnc, 'lbl_tnc')}
              </Anchor>
            </Col>
          </div>
        </>
      )}
    </div>
  );
};

PlaceRewardsSection.propTypes = {
  className: PropTypes.string,
  isBonusPointsEnabled: PropTypes.bool,
};

PlaceRewardsSection.defaultProps = {
  className: '',
  isBonusPointsEnabled: false,
};

export default withStyles(PlaceRewardsSection, styles);
export { PlaceRewardsSection as PlaceRewardsSectionVanilla };
